/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import Button from 'components/Button';

export const TemplateButton = styled(Button)`
  margin: 0 20px 20px 0;
  padding: 30px 50px;
  border-radius: 5px !important;
  transition: all 0.25s cubic-bezier(0.55,0.085,0.68,0.53);

  &:hover {
    background: var(--blue-primary);
    color: white;
  }

  @media (max-width: 576px) {
    padding: 20px;
    font-size: 18px;
    margin: 0 10px 10px 0;
  }
`;